/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

 export type AggregationInterval = 'YEAR' | 'MONTH' | 'WEEK' | 'DAY';
 export type AggregationIntervalDisplay = 'Yearly' | 'Monthly' | 'Weekly' | 'Daily';
 export const mapAggregationInterval = (aggregationInterval: AggregationInterval): AggregationIntervalDisplay | null => {
   let aggregationIntervalToDisplay: AggregationIntervalDisplay | null = null;
   if (aggregationInterval === 'YEAR') {
     aggregationIntervalToDisplay = 'Yearly';
   } else if (aggregationInterval === 'MONTH') {
     aggregationIntervalToDisplay = 'Monthly';
   } else if (aggregationInterval === 'WEEK') {
     aggregationIntervalToDisplay = 'Weekly';
   } else if (aggregationInterval === 'DAY') {
     aggregationIntervalToDisplay = 'Daily';
   }
   return aggregationIntervalToDisplay;
 };
 export interface RlFlLinkUsage {
   flUsageBytes: number;
   rlUsageBytes: number;
 }
 export interface DataUsageBase {
   fromMsSinceEpoch: number;
   toMsSinceEpoch: number;
   datapathUuids: string[];
 }
 export interface AggregatedDataUsageBase extends DataUsageBase {
   fromMsSinceEpoch: number;
   toMsSinceEpoch: number;
   datapathUuids: string[];
   aggregationInterval: AggregationInterval;
 }
 
 export interface DataUsageRequestPayload {
   fromMsSinceEpoch: number;
   toMsSinceEpoch: number;
   datapathUuids: string[];
 }
 export interface AggregatedDataUsageRequestPayload extends DataUsageRequestPayload {
   aggregationInterval: AggregationInterval;
 }
 export interface TotalUsageByNetwork extends DataUsageBase {
   kaUsageBytes: number;
   kuUsageBytes: number;
 }
 
 export interface TotalUsageByLink extends DataUsageBase {
   rlUsageBytes: number;
   flUsageBytes: number;
 }
 
 export interface UsageByLink extends AggregatedDataUsageBase {
   usageByLinkBytes: { [sourceTime: number]: RlFlLinkUsage };
 }
 export interface UsageByLinkCumulative extends AggregatedDataUsageBase {
   usageByLinkBytes: { [sourceTime: number]: RlFlLinkUsage };
 }
 
 export interface UsageByNetwork extends AggregatedDataUsageBase {
   kaUsageBytes: { [sourceTime: number]: number };
   kuUsageBytes: { [sourceTime: number]: number };
 }
 
 export interface CumulativeUsageByNetwork extends AggregatedDataUsageBase {
   kaCumulativeUsageBytes: { [sourceTime: number]: number };
   kuCumulativeUsageBytes: { [sourceTime: number]: number };
 }
 
 export interface TotalPacketLossByLink extends DataUsageBase {
   lossPercentage: number;
 }
 
 export interface PacketLossByLink extends AggregatedDataUsageBase {
   packetLossByLinkPercentage: { [sourceTime: number]: RlFlPacketLoss };
 }

 export interface ServiceAvailabilityValues {
  uptime: number;
  downtime: number;
  serviceAvailabilityPercentage: number;
 }

 export interface ServiceAvailability extends AggregatedDataUsageBase {
   serviceAvailability: { [timestamp: string] : ServiceAvailabilityValues }
 }
 
 export interface RlFlPacketLoss {
   flLossPercentage: number;
   rlLossPercentage: number;
 }